module.exports = __webpack_public_path__ + "media/images/cleaning/meriem-b92efb71ee5860c39810036f4587e6d6.jpg";